import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7efaf0bf"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["value"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        height: null,
        width: null,
        model: null,
        selectionList: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const model = ref(props.model);
        const onModelChange = () => {
            emit('change', model.value);
        };
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                onChange: onModelChange,
                class: "select",
                style: _normalizeStyle({
                    height: !!props.height ? `${props.height}px` : undefined,
                    width: `${props.width}px`,
                })
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectionList, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                        key: item.value,
                        value: item.value,
                        class: "option"
                    }, _toDisplayString(item.title), 9, _hoisted_1));
                }), 128))
            ], 36)), [
                [_vModelSelect, model.value]
            ]);
        };
    }
});
